import { Navbar } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import images from '../assets/images';
import type { IFederatedHeaderProps } from '../types/propTypes';

const FederatedHeader = ({ displayName }: IFederatedHeaderProps) => {
  const { t } = useTranslation();

  return (
    <header className="header">
      <div className="container-xl">
        <div className="row no-gutters align-items-center">
          <div className="col">
            <Navbar expand="lg">
              <img src={images.logoPNG} alt={t<string>('navbar.title')} />
            </Navbar>
          </div>
          <div className="col-auto">
            {displayName ? (
              <div className="manage-access-right-bar">
                <div className="manage-access-user-block align-items-center">
                  <img className="manage-access-user-icon" src={images.avatarSVG} alt="" />
                  <span
                    className="manage-access-name text-truncate capitalize avatarIcon"
                    title={displayName}
                    style={{ color: 'white' }}
                  >
                    {displayName}
                  </span>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </header>
  );
};

export default FederatedHeader;
